import isWeb from './isWeb';

let isQQ = false;

if (isWeb) {
    const ua = (navigator && navigator.userAgent) || '';
    isQQ = /QQ/i.test(ua);
}

export default isQQ;
